.pes-select {
  width: 100%;
  min-width: 250px;
  max-width: 100%;
}

@media screen and (min-width: 980px) {
  .pes-select--fixed-width {
    width: 250px;
  }
}